import { render } from "./SectionTitle.vue?vue&type=template&id=f55bdb16"
const script = {}

import exportComponent from "/var/www/sostoolkit-live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__